/**
 * Boolean Field Default Configuration
 *
 * Toggle/checkbox field for true/false values.
 * Properties aligned with API JSON configuration structure.
 */

export interface BooleanFieldConfig {
  label: string;
  showTitle: boolean;
  exclusionType: 'hide' | 'disable';
  displayName: string;
  shortDisplayName?: string;
  required: boolean;
  value: boolean;
  trueLabel: string;
  falseLabel: string;
}

export const BOOLEAN_DEFAULT_CONFIG: Omit<BooleanFieldConfig, 'label' | 'displayName'> = {
  showTitle: true,
  exclusionType: 'hide',
  shortDisplayName: '',
  required: false,
  value: false,
  trueLabel: 'Yes',
  falseLabel: 'No',
};

/**
 * Create default configuration for a boolean field
 * @param fieldName The field name to use as label
 */
export const createBooleanConfig = (fieldName: string): BooleanFieldConfig => ({
  ...BOOLEAN_DEFAULT_CONFIG,
  label: fieldName,
  displayName: '',
});

export default createBooleanConfig;
